module.exports = __webpack_public_path__ + "static/media/image.153eee4a.svg";